import { render, staticRenderFns } from "./Tribune.vue?vue&type=template&id=a2bb70a0&scoped=true&"
import script from "./Tribune.vue?vue&type=script&lang=js&"
export * from "./Tribune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bb70a0",
  null
  
)

export default component.exports